/* Sham FAQ Page - JS Logic */

class ShamFaqPage extends HTMLElement {
    connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
        this.bindItems();
        this.bindDeepLinks();
        this.observeGroups();
        this.openFromHash();
    }

    bindItems() {
        this.items.forEach((item) => {
            const trigger = item.querySelector('.sham-faq-page__trigger');
            if (!trigger) return;
            trigger.addEventListener('click', () => this.toggle(item));
        });
    }

    bindDeepLinks() {
        window.addEventListener('hashchange', () => this.openFromHash());
    }

    toggle(item) {
        if (item.classList.contains('is-active')) {
            this.close(item);
        } else {
            this.open(item);
        }
    }

    open(item) {
        item.classList.add('is-active');
        const wrapper = item.querySelector('.sham-reveal-wrapper');
        if (wrapper) wrapper.classList.add('is-expanded');
        const trigger = item.querySelector('.sham-faq-page__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    close(item) {
        item.classList.remove('is-active');
        const wrapper = item.querySelector('.sham-reveal-wrapper');
        if (wrapper) wrapper.classList.remove('is-expanded');
        const trigger = item.querySelector('.sham-faq-page__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    // A link into #faq-<slug>-<n> must open that question, not just scroll to a
    // collapsed row. CSS scroll-margin-top handles the header offset.
    openFromHash() {
        const hash = window.location.hash;
        if (!hash || hash.length < 2) return;

        let heading;
        try {
            // A browser text fragment (#:~:text=...), appended on arrival from a
            // search snippet, is not a valid CSS selector and throws otherwise.
            heading = this.querySelector(hash);
        } catch {
            return;
        }
        if (!heading) return;

        const item = heading.closest('[data-faq-item]');
        if (!item) return;

        this.open(item);
        heading.scrollIntoView({ block: 'start' });
    }

    observeGroups() {
        const links = Array.from(document.querySelectorAll('[data-faq-rail-link]'));
        if (links.length === 0) return;

        const headings = Array.from(this.querySelectorAll('.sham-faq-page__group-title'));
        if (headings.length === 0) return;

        const setCurrent = (id) => {
            links.forEach((link) => {
                link.classList.toggle('is-current', link.dataset.faqRailLink === id);
            });
        };

        setCurrent(headings[0].id);

        const visible = new Set();
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        visible.add(entry.target.id);
                    } else {
                        visible.delete(entry.target.id);
                    }
                });

                const current = headings.find((heading) => visible.has(heading.id));
                if (current) setCurrent(current.id);
            },
            // Top band only: a heading counts as current once it reaches the
            // upper quarter of the viewport and stops counting when it leaves.
            { rootMargin: '0px 0px -75% 0px', threshold: 0 }
        );

        headings.forEach((heading) => observer.observe(heading));
    }
}

customElements.define('sham-faq-page', ShamFaqPage);
